import styled from 'styled-components'

export const Wrapper = styled.div`
  margin-top: 12px;
`

export const SectorsContainer = styled.section`
  margin: 48px 0;

  section {
    margin-top: 18px;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-row-gap: 18px;
  }
`

export const TeamsContainer = styled.section`
  margin: 48px 0;

  ul {
    display: flex;
    padding: 12px;
    margin-top: 12px;
    border-radius: ${({ theme }) => theme.border.radius.small};
    background-color: ${({ theme }) => theme.colors.white};

    li {
      padding: 4px 10px;
      font-size: ${({ theme }) => theme.font.sizes.xsmall};
      background-color: ${({ theme }) => theme.colors.primary};
      color: ${({ theme }) => theme.colors.white};
      border-radius: ${({ theme }) => theme.border.radius.medium};
    }
  }
`

export const Title = styled.h2`
  text-transform: uppercase;
  font-size: ${({ theme }) => theme.font.sizes.medium};
  font-weight: 500;
  color: ${({ theme }) => theme.colors.primary};
  margin-bottom: 24px;
`

export const PendencySelection = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`

export const PendencyJustification = styled.div`
  textarea {
    height: 160px;
  }

  & + & {
    margin-top: 80px;
  }
`

export const ActionsButtons = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 48px;

  button {
    background-color: ${({ theme }) => theme.colors.mainBg};
  }

  @media (max-width: 1024px) {
    flex-direction: column;
    justify-content: center;
  }
`
